import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Sidebar } from './components/sidebar';
import { Auth } from './pages/auth';
import Home from './pages/home';
import { ExploreSoundworld } from './pages/explore';
import { TrainSoundworld } from './pages/train';
import { CatalogueTools } from './pages/catalogue/CatalogueTools';
import { TransferGenrePage } from './pages/catalogue/derivative';
import { NewTrackPage } from './pages/catalogue/newTrack';
import { CreditsPage } from './pages/credits';
import { ProjectDetailsPage } from './pages/projectDetailsPage';
import { GeneratorPage } from './pages/explore/GeneratorPage';
import { AudioUtilitiesPage } from './pages/audioUtilities';
import { UpdateDetailsPage } from './pages/updates/UpdateDetails';
import { SoundworldsProvider } from './contexts/SoundworldsContext';
import { CreditsProvider } from './contexts/CreditsContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { useWebSocket } from './hooks/useWebSocket';
import { forceEnableWebSocket, clearWebSocketDisabledFlag } from './utils/websocketUtils';

function AppContent({ username, setUsername }) {
  const location = useLocation();
  const { connect } = useWebSocket();

  useEffect(() => {
    const allAudioElements = document.querySelectorAll('audio');
    allAudioElements.forEach(audio => {
      if (audio instanceof HTMLAudioElement) {
        audio.pause();
        audio.currentTime = 0;
      }
    });

    window.dispatchEvent(new CustomEvent('stopAllAudio'));
  }, [location.pathname]);

  return (
    <div className="flex font-inter h-screen">
      <Sidebar />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={ <Auth setUsername={ setUsername } /> } />
          <Route path="/home" element={ <Home /> } />
          <Route path="/explore" element={ <ExploreSoundworld /> } />
          <Route path="/generator/:projectId" element={ <GeneratorPage /> } />
          <Route path="/train" element={ <TrainSoundworld /> } />
          <Route path="/catalogue" element={ <CatalogueTools username={ username } /> } />
          <Route path="/derivative" element={ <TransferGenrePage username={ username } /> } />
          <Route path="/new-track" element={ <NewTrackPage username={ username } /> } />
          <Route path="/credits" element={ <CreditsPage /> } />
          <Route path="/catalogue/:projectId" element={ <ProjectDetailsPage username={ username } /> } />
          <Route path="/audio-utilities" element={ <AudioUtilitiesPage /> } />
          <Route path="/updates/:id" element={ <UpdateDetailsPage /> } />
        </Routes>
      </div>
    </div>
  );
}

export default function App() {
  const [username, setUsername] = useState(localStorage.getItem("name") || '');

  // Initialize WebSocket globally
  const { connect } = useWebSocket();

  useEffect(() => {
    const lastInetrval = localStorage.getItem('ping_test_interval');
    if (lastInetrval) {
      clearInterval(parseInt(lastInetrval));
    }
    const interval = setInterval(() => {
      const pingTime = localStorage.getItem('last_ws_ping');
      const elapsed = pingTime ? Date.now() - parseInt(pingTime) : null;
      // console.log(`Last ping time: ${elapsed}` );
      // console.log(`Inreval: ${localStorage.getItem('ping_test_interval')}`);
      if (!pingTime) {
        console.warn('No ping received yet');
      }
      if (elapsed && elapsed > 40000) {
        console.warn(`WebSocket ping timeout, disconnecting... ${elapsed}`);
        // disconnect();
        connect();
      }
    }, 5000);
    localStorage.setItem('ping_test_interval', interval.toString());
    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    forceEnableWebSocket();
    clearWebSocketDisabledFlag();
  }, []);

  return (
    <ThemeProvider>
      <SoundworldsProvider>
        <CreditsProvider>
          <Router>
            <AppContent username={ username } setUsername={ setUsername } />
          </Router>
          <Toaster
            position="top-right"
            toastOptions={ {
              duration: 4000,
              style: {
                background: 'hsl(var(--card))',
                color: 'hsl(var(--card-foreground))',
                border: '1px solid hsl(var(--border))',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: 'hsl(var(--special-offer))',
                  secondary: 'hsl(var(--special-offer-foreground))',
                },
              },
              error: {
                duration: 4000,
                iconTheme: {
                  primary: 'hsl(var(--destructive))',
                  secondary: 'hsl(var(--destructive-foreground))',
                },
              },
            } }
          />
        </CreditsProvider>
      </SoundworldsProvider>
    </ThemeProvider>
  );
}
